import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './UseCases.css';

const UseCases = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const { language } = useLanguage();
  const t = getTranslation(language);

  return (
    <section id="solutions" className="use-cases" ref={ref}>
      <div className="use-cases-container">
        <motion.div
          className="use-cases-header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">{t.applications.title}</h2>
          <p className="section-subtitle">
            {t.applications.subtitle}
          </p>
        </motion.div>

        <div className="use-cases-grid">
          {t.applications.cases.map((useCase, index) => (
            <motion.div
              key={index}
              className="use-case-card"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
            >
              {/* Image Slot 3: Industry icon placeholder */}
              <div className="use-case-icon">
                <div className="icon-placeholder">{useCase.icon}</div>
              </div>
              <h3 className="use-case-title">{useCase.title}</h3>
              <p className="use-case-description">{useCase.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
